import request from '@/api/request'

export default {
  async getOrderShippingMethods () {
    return (await request.get(`module/action/erp/tiny/order_shipping_method/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/erp/tiny/index.js